import { render, staticRenderFns } from "./autoReply.vue?vue&type=template&id=2b275c5f&scoped=true&"
import script from "./autoReply.vue?vue&type=script&lang=js&"
export * from "./autoReply.vue?vue&type=script&lang=js&"
import style0 from "./autoReply.vue?vue&type=style&index=0&id=2b275c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b275c5f",
  null
  
)

export default component.exports